import { type ParamTypesOf } from 'hb-react/shared/hooks/useParsedQueryParams/types';

export interface PageLocaleParams {
  pageLocale?: string;
}

export const paramTypesForPageLocale = ({
  defaultLocale,
}: {
  defaultLocale: string;
}): ParamTypesOf<PageLocaleParams> => ({
  pageLocale: {
    type: 'string',
    defaultValue: defaultLocale,
  },
});
